import {
	ADMINADDORUPDATEKYCDOCUMENT_SUCCESS,
	ADMINADDORUPDATEKYCDOCUMENT_FAILED,
	RESET_ADMINADDORUPDATEKYCDOCUMENT,
	LOADING_ADMINADDORUPDATEKYCDOCUMENT,
	NETWORK_ERROR_ADMINADDORUPDATEKYCDOCUMENT
} from "../types/index";

const initialState = {
	isLoading: false,
	success: false,
	network: false,
	failed: false,
	data: {}
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOADING_ADMINADDORUPDATEKYCDOCUMENT:
			return {
				...state,
				isLoading: true,
				success: false,
				failed: false,
				network: false,
				data: {}
			};
		case ADMINADDORUPDATEKYCDOCUMENT_FAILED:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: true,
				network: false,
				data: action.payload
			};
		case ADMINADDORUPDATEKYCDOCUMENT_SUCCESS:
			return {
				...state,
				isLoading: false,
				success: true,
				failed: false,
				network: false,
				data: action.payload
			};
		case NETWORK_ERROR_ADMINADDORUPDATEKYCDOCUMENT:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: false,
				network: true,
				data: {}
			};
		case RESET_ADMINADDORUPDATEKYCDOCUMENT:
			return (state = initialState);
		default:
			return state;
	}
};
